import { Tooltip } from "antd";
import { useEffect, useState } from "react";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { useSearchParams } from "react-router-dom";
import CollapseRankFaculty from "Benchmarking/Components/CollapseRankFaculty";
import { IconPack } from "Benchmarking/Config/Icons";
import "Benchmarking/Scss/RankFaculty.scss";
import { getAuthorRank } from "Benchmarking/Services/Author";

const RankFaculty = () => {
  const [searchParams] = useSearchParams();
  const selectedKeywordsSetup = searchParams
    .get("keywords")
    ?.split("-")
    .slice(0, -1)
    .map((item) => item.replace(/_/g, " "));
  const selectedInstitutionSetup = searchParams
    .get("institutions")
    ?.split("-")
    .slice(0, -1)
    .map((item) => item.replace(/_/g, " "));
  const selectedDepartmentSetup = searchParams
    .get("departments")
    ?.split("-")
    .slice(0, -1)
    .map((item) => item.replace(/_/g, " "));
  const timeRangeSetup = searchParams.get("time_range");
  const [filters, setFilters] = useState({
    keywords: selectedKeywordsSetup ? selectedKeywordsSetup : [],
    institutions: selectedInstitutionSetup ? selectedInstitutionSetup : [],
    departments: selectedDepartmentSetup ? selectedDepartmentSetup : [],
    time_range: timeRangeSetup ? timeRangeSetup : "",
    classifications: [],
  });
  const [rankData, setRankData] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [copyLink, setCopyLink] = useState(false);

  useEffect(() => {
    setIsLoading(true);
    setRankData([]);
    getAuthorRank(filters, (res) => {
      setRankData(res);
      setIsLoading(false);
    });
  }, [filters]);

  const handleCopyToClipBoard = () => {
    let url_link = "http://103.3.245.20:5005/benchmarking/faculty/rank?";
    if (filters["keywords"]) {
      url_link += "keywords=";
      filters["keywords"].map((item) => {
        const newStr = item.replace(/ /g, "_");
        url_link += newStr + "-";
      });
      url_link += "&";
    }
    if (filters["time_range"]) {
      url_link += `time_range=${filters["time_range"]}&`;
    }
    if (filters["institutions"]) {
      url_link += "institutions=";
      filters["institutions"].map((item) => {
        const newStr = item.replace(/ /g, "_");
        url_link += newStr + "-";
      });
      url_link += "&";
    }
    if (filters["departments"]) {
      url_link += "departments=";
      filters["departments"].map((item) => {
        const newStr = item.replace(/ /g, "_");
        url_link += newStr + "-";
      });
      url_link += "&";
    }
    return url_link;
  };
  return (
    <div className="rank-faculty scroll-section">
      <CollapseRankFaculty
        filters={filters}
        setFilters={setFilters}
        rankData={rankData}
        isLoading={isLoading}
      />
      <div className="save-button">
        <CopyToClipboard
          text={handleCopyToClipBoard()}
          onCopy={(text, result) => {
            console.log(text, result);
          }}
        >
          <Tooltip title={copyLink == false ? "Copy link" : "Copied"}>
            <div className="copy-link" onClick={() => setCopyLink(true)}>
              {IconPack.copy_link}
            </div>
          </Tooltip>
        </CopyToClipboard>
        <button>Save</button>
      </div>
    </div>
  );
};

export default RankFaculty;
